import { createSaga } from './saga-helpers';

import * as Api from '../api/apps-api';

const watchGetApps = createSaga({
    type: 'APPS_FETCH',
    fn: Api.fetchApps,
    args: action => [action.payload],
    successPayload: ({ apps, hasMore } = {}, action) => ({
        apps: apps,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateApp = createSaga({
    type: 'APP_CREATE',
    fn: Api.createApp,
    args: action => [action.payload.app],
    successPayload: (app, action) => ({
        appId: app.id,
        app,
        fragment: action.payload.app
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.app
    })
});

const watchGetApp = createSaga({
    type: 'APP_FETCH',
    fn: Api.fetchApp,
    args: action => [action.payload.appId],
    successPayload: app => ({ app })
});

const watchUpdateApp = createSaga({
    type: 'APP_UPDATE',
    fn: Api.updateApp,
    args: action => [action.payload.appId, action.payload.appProps],
    successPayload: app => ({ app })
});

const watchRemoveApp = createSaga({
    type: 'APP_REMOVE',
    fn: Api.removeApp,
    args: action => [action.payload.appId]
});

const sagas = [watchGetApps, watchCreateApp, watchGetApp, watchUpdateApp, watchRemoveApp];

export default sagas;
